export const UserRoutes = {
  createUser: "admin/create-user",
  viewAllUser: "admin/get-users",
  updateUser:"admin/update-user/",
  deletUser:"admin/delete-user/"

};
